<template>
  <div
    class="card mb-3 border-0 shadow-sm custom-branch-card"
    :key="branch.branch_id"
  >
    <div class="bg-white border-bottom-0 card-header d-flex justify-content-between rounded-top">
      <div class="d-flex align-items-center">
        <div class="branch-icon me-3 bg-theme text-white">
          <i class="fa-solid fa-shop"/>
        </div>
        <div>
          <h6 class="mb-0 fw-bold text-theme">{{ branch.name }}</h6>
          <small class="text-muted" v-if="branch.code">{{ $t('Code') + ': ' + branch.code }}</small>
        </div>
      </div>
    </div>

    <div class="card-body bg-white pt-0 rounded-bottom">
      <hr class="mt-0 mb-3 text-black-50">

      <label class="form-label small fw-semibold text-muted mb-2">{{ $t('Settings') }}</label>
      <div class="border rounded p-3">
        <div class="row align-items-center">
          <div class="col-7 col-md-8">
            <div class="fw-semibold">{{ $t('Stock Status') }}</div>
            <small class="text-muted">{{ $t('Mark this inventory as in stock for this branch.') }}</small>
          </div>
          <div class="col-5 col-md-4">
            <div class="form-check form-switch d-flex align-items-center justify-content-end mb-0 ps-0">
              <span
                class="me-2 small fw-semibold"
                :class="branch.is_in_stock ? 'text-success' : 'text-danger'"
              >
                {{ branch.is_in_stock ? $t('In Stock') : $t('Out of Stock') }}
              </span>
              <input
                class="form-check-input shadow-none ms-0"
                type="checkbox"
                role="switch"
                v-model="branch.is_in_stock"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-setting-branch-item";

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.branch);
  },
  props: {
    branch: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      required: true
    }
  }
}
</script>
